import { useEffect, useState } from "react";

// Tracks window.visualViewport.height in real time.
// On iOS, visualViewport shrinks when the keyboard appears,
// giving us the actual visible height above the keyboard.
const useStableViewportHeight = () => {
  const [height, setHeight] = useState(
    () => window.visualViewport?.height ?? window.innerHeight,
  );

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => setHeight(vv.height);
    vv.addEventListener("resize", onResize);
    return () => vv.removeEventListener("resize", onResize);
  }, []);

  return height;
};

export default useStableViewportHeight;
